<div class="container addQuestions">
  <div class="">
    <!-- <form [formGroup]="fileUploadForm"> -->
    <div class="row">
  
      <div class="col-12 col-md-12 col-lg-12 col-xl-12 p-2 mt-2 mb-4 unq">
        <div class="card">

          <!-- <div class="row d-flex p-3 m-0 border-bottom">
            <div class="heading_1  mr-auto header">Uploading  {{selectedValue}}</div>
          </div> -->

          <h1 mat-dialog-title class="d-flex align-items-center justify-content-between">
            <span>Uploading  {{selectedValue}}</span>
            <i class="fa fa-times model_close cursor-pointer" (click)="cancel()"></i>
          </h1>
        <form class="model_form" [formGroup]="fileUploadForm">
          <div class="row m-0">
              <div class="col-12 p-0">
                <div class="row">
                  
                  <div class="col-12 col-md-4 col-lg-4 mb-2">
                    <!-- <div class="pr-2">
                      <span class="secondaryInfo">File Type *</span>
                    </div> -->
                    <div>
                      <span class="labelName">File Type<sup class="requiredStar">*</sup></span>
                    </div>
                    <select formControlName="fileType" [(ngModel)]="selectedValue"  (ngModelChange)="onSelected()" class="form-control" required>
                      <option [ngValue]="undefined" disabled selected>--Select File Type--</option>
                      <option value="Questions">Questions</option>
                      <option value="Assumptions">Assumptions</option>
                      <option value="Scope IN">Scope IN</option>
                      <option value="Scope Out">Scope Out</option>
                    </select>
                    <div class="error" *ngIf="fileUploadForm.get('fileType').invalid && (fileUploadForm.get('fileType').dirty || fileUploadForm.get('fileType').touched)">
                      Please select a file type.
                    </div>
                  </div>
                
                  <div class="col-12 col-md-4 col-lg-4 mb-2">
                    <div>
                      <span class="labelName">Vertical<sup class="requiredStar">*</sup></span>
                    </div>
                    <select formControlName="domain" [(ngModel)]="domainValue" (ngModelChange)="domainChange()" class="form-control" required>
                      <option [ngValue]="undefined" disabled selected>--Select Vertical--</option>
                      <option *ngFor="let category of domains" [value]="category">{{ category }}</option>
                    </select>
                    <div class="error" *ngIf="fileUploadForm.get('domain').invalid && (fileUploadForm.get('domain').dirty || fileUploadForm.get('domain').touched)">
                      Please select a Vertical.
                    </div>
                  </div>


                  <div class="col-12 col-md-4 col-lg-4 mb-2">
                    <div>
                      <span class="labelName">Proposals<sup class="requiredStar">*</sup></span>
                    </div>
                    <select formControlName="proposal" [(ngModel)]="proposalValue" (ngModelChange)="proposalChange()" class="form-control" required>
                      <option [ngValue]="undefined" disabled selected>--Select Proposal--</option>                    
                        <option *ngFor="let proposal of customerNames" [value]="proposal">{{ proposal }}</option>                   
                      <!-- <option *ngFor="let proposal of proposals" [value]="proposal">{{ proposal }}</option>                     -->
                    </select>                                      
                    <div class="error" *ngIf="fileUploadForm.get('proposal').invalid && (fileUploadForm.get('proposal').dirty || fileUploadForm.get('proposal').touched)">
                      Please select a proposal.
                    </div>
                  </div>


                  <div class="col-12 col-md-4 col-lg-4 mb-2" *ngIf="proposalValue === 'Other'">
                    <div>
                      <span class="labelName">Other Proposal<sup class="requiredStar">*</sup></span>
                    </div>
                    <input type="text" class="form-control" placeholder="Enter proposal name" formControlName="otherProposal" [(ngModel)]="otherProposalValue" (ngModelChange)="updateFileInputStatus()">
                    <div class="error" *ngIf="fileUploadForm.get('otherProposal').invalid && (fileUploadForm.get('otherProposal').dirty || fileUploadForm.get('otherProposal').touched)">
                      Please enter a other proposal name.
                    </div>
                  </div>


            <!-- <div class="col-12 col-md-4 col-lg-4">
              <div class="pr-44">
                <label class="secondaryInfo" for="fileInput">Upload Excel File:*</label>
                <input type="file" id="fileInput"  [disabled]="isFileInputDisabled"  accept=".xlsx, .xls" (change)="handleFileInput($event)">
              </div>
              <div class="error" *ngIf="fileUploadForm.get('fileInput').invalid && (fileUploadForm.get('fileInput').dirty || fileUploadForm.get('fileInput').touched)">
                Please select an Excel file.
              </div>
            </div> -->

            <div class="col-12 col-md-4 col-lg-4 mb-2">
              <div>
                <span class="labelName">Upload Excel File :<sup class="requiredStar">*</sup></span>
              </div>
              <!-- <div class="pr-44">
                <label class="secondaryInfo" for="fileInput">Upload Excel File:*</label>
              </div> -->
              <input type="file" id="fileInput" class="form-control" name="fileInput" [disabled]="isFileInputDisabled" accept=".xlsx, .xls" (change)="handleFileInput($event)">
              <div class="error" *ngIf="fileUploadForm.controls['fileInput'].invalid && (fileUploadForm.controls['fileInput'].dirty || fileUploadForm.controls['fileInput'].touched)">
                Please select an Excel file.
              </div>
            </div>

            <div class="pb-3 mt-4 border-top w-100"></div>
                  

            <div  class="add-icon1" *ngIf="questionsData.length > 0">
              <button mat-icon-button color="primary" (click)="toggleAddMode()">
                <mat-icon>add</mat-icon>
              </button>
            </div>


            

            <div class="questionsView" *ngIf="questionsData.length > 0">
              <table class="custom-table">
                <thead>
                  <tr>
                    <th class="No">NO</th>
                    <th class="question-name">{{selectedValue}} </th>
                    <!-- <th class="question-description">Question Description</th> -->
                    <th class="actions">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let question of questionsData; let i = index">
                    <tr>
                      <td>{{ i + 1 }}</td>
                      <td>
                        <ng-container *ngIf="editingIndex !== i; else editRow">
                          {{ question.name }}
                        </ng-container>
                        <ng-template #editRow>
                          <!-- [ngStyle]="calculateInputStyle(editedQuestion.name)" -->
                          <textarea  [(ngModel)]="editedQuestion.name" [rows]="calculateTextareaRows(editedQuestion.name)" style="resize: none; width:100%;" [ngModelOptions]="{standalone: true}"></textarea>
                        </ng-template>
                      </td>
                      <!-- <td>
                        <ng-container *ngIf="editingIndex !== i; else editRowDesc">
                          {{ question.description }}
                        </ng-container>
                        <ng-template #editRowDesc>
                          <textarea  type="text"   [(ngModel)]="editedQuestion.description"  [rows]="calculateTextareaRows(editedQuestion.description)" style="resize: none; width:100%;"></textarea>
                        </ng-template>
                      </td> -->
                      <td class="actions-edit">
                        <ng-container *ngIf="editingIndex !== i; else editActions">
                          <!-- <button mat-icon-button color="primary" (click)="toggleAddMode(i)">
                            <mat-icon>add</mat-icon>
                          </button> -->
                          <button mat-icon-button color="primary" (click)="editQuestion(i)">
                            <mat-icon>edit</mat-icon>
                          </button>
                          <button mat-icon-button color="warn" (click)="deleteQuestion(i)">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </ng-container>
                        <ng-template #editActions>
                          <button mat-icon-button color="primary" (click)="saveEdit(i)">
                            <mat-icon>save</mat-icon>
                          </button>
                          <button mat-icon-button color="warn" (click)="cancelEdit()">
                            <mat-icon>cancel</mat-icon>
                          </button>
                        </ng-template>
                      </td>
                    </tr>                
                  </ng-container>
                  <tr *ngIf="addModeIndex !== null" class="add-row">
                    <td></td>
                    <td> <textarea  type="text"  style="width: 100%; min-height: 100px;" [(ngModel)]="newQuestion.name" placeholder="Enter question name" [ngModelOptions]="{standalone: true}" ></textarea></td>
                    <td>
                      <button mat-icon-button color="primary" (click)="saveNewQuestion()">
                        <mat-icon>save</mat-icon>
                      </button>
                      <button mat-icon-button color="warn" (click)="cancelAdd()">
                        <mat-icon>cancel</mat-icon>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="col-12 col-lg-12 col-md-12 d-flex justify-content-end">

              <div class="buttons_column align-self-center">          
                <button type="button" class="custom_btn inverted_btn_base mr-3" id="inv_setup_cancel"
                data-backdrop="static" data-keyboard="false" (click)="cancel()">Close</button>
                <button type="button" class="custom_btn primary_btn_base" id="inv_setup_save"
                data-backdrop="static" data-keyboard="false" (click)="SaveData()" [disabled]="!isSaveButtonEnabled()">Save</button>
              </div>

            </div>

            </div>
            </div>
          </div>
        </form>

          </div>

          </div>
          </div>
          </div>
          </div>
         
          